import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { DocumentTypeDocument, documentTypePullQueryBuilder } from './queryBuilder';

export function documentTypesFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<DocumentTypeDocument> {
  const syncConfig = configBuilder<DocumentTypeDocument>(RxdbCollectionNameV2.DOCUMENT_TYPES);
  doNotAutoSync(syncConfig);

  // `documentTypePullQueryBuilder` uses `borerDocumentTypesBySiteIdFeed` and thus corresponds to `borer_document_type`
  pull(syncConfig, documentTypePullQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy had syncInterval at LiveInterval.MINUTES_15
  return create(RxdbCollectionNameV2.DOCUMENT_TYPES, replicationState, [sites]);
}
